import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules'
import { animate, inView, scroll } from "motion"
import 'npm:swiper/swiper.css';

export const testimonialsSlider = (slider) => {
  if (slider.querySelectorAll('.swiper-slide').length > 1) {
    const swiper = new Swiper(slider, {
      modules: [Mousewheel],
      direction: 'vertical',
      slidesPerView: 1,
      autoHeight: true,
      mousewheel: {
        releaseOnEdges: true,
        sensitivity: 0.05
      },
      mousewheelControl: true,
      touchReleaseOnEdges: true,
      speed: 600,
      on: {
        slideChange: function () {
          setTimeout(function () {
            swiper.params.mousewheel.releaseOnEdges = false;
          }, 500);
        },
        reachEnd: function () {
          setTimeout(function () {
            swiper.params.mousewheel.releaseOnEdges = true;
          }, 750);
        }
      }
    });
  }
}

export const scrollTo = (element) => {
  const parent = element.closest('.praxent_testimonials');
  const slides = element.querySelectorAll('.swiper-slide');
  if (slides.length > 1) {
    const parentOffset = parent.offsetTop;
    inView(parent,
      () => {
        console.log("Element has entered the viewport");
        window.scrollTo({
          top: parentOffset - 92,
          behavior: "smooth",
        });
      },
      { margin: "-300px" }
    )
  }
}